// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.10-6UolF5LZuIaZoDlY8wmT/mode=imports,min/optimized/keen-slider.js'

const { setInitialised, useArrows, useDots } = window.BAO.Carousel.plugins

class ProductCardGallery extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  async connectedCallback () {
    super.connectedCallback()

    await new Promise(resolve => setTimeout(resolve, 100))

    this.carousel = this.setupCarousel()
  }

  disconnectedCallback () {
    this.destroyCarousel()

    this.els.card?.element.removeEventListener('mouseenter', () => {
      this.carousel.moveToIdx(1, { animation: false })
    })

    this.els.card?.element.removeEventListener('mouseleave', () => {
      if (this.carousel.track.details.rel !== 0) {
        this.carousel.moveToIdx(0, { animation: false })
      }
    })
  }

  destroyCarousel () {
    if (this.carousel && typeof this.carousel.destroy === 'function') {
      this.carousel.destroy()
      this.carousel = null
    }
  }

  reinitialise () {
    this.destroyCarousel()
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    const slider = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        slides: {
          perView: 1,
          spacing: 0,
        },
        defaultAnimation: {
          duration: 0, // Animation duration in milliseconds
        },
        slideChanged: slider => {
          this.updateActiveSlideClass(slider)
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        this.els?.dot?.elements ? useDots(this.els.dot.elements) : null,
      ],
    )

    this.els.card?.element.addEventListener('mouseenter', () => {
      this.carousel.moveToIdx(1, { animation: false })
    })

    this.els.card?.element.addEventListener('mouseleave', () => {
      if (this.carousel.track.details.rel !== 0) {
        this.carousel.moveToIdx(0, { animation: false })
      }
    })

    return slider
  }

  updateActiveSlideClass (slider) {
    const slides = this.els.slides.element.querySelectorAll(
      this.els.slide.selector,
    )

    slides.forEach((slide, idx) => {
      if (idx === slider.track.details.rel) {
        slide.classList.add('prd-Card_Image-active')
      } else {
        slide.classList.remove('prd-Card_Image-active')
      }
    })
  }
}

window.customElements.define('product-card-gallery', ProductCardGallery)
